import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Addoptions from './addoption';
import { bindActionCreators } from 'redux';
import * as QuestionnaireActions from '../../actions/questionnaire_actions';
import _ from 'lodash';
import { ModalDialogCommon } from '../modal_dialog_common';
import { validate } from '../../validations';
let Question = React.createClass({
    getInitialState() {
        return {

            MinValuesSlider: "",
            MaxValuesSlider: "",
            MidValuesSlider: "",
            MaxValuesSliderOpt: "",
            MinValuesSliderOpt: "",
            MidValuesSliderOpt: "",
            selectedIcon: null,
            selectedLabel: "Select Options",
            followAnswer: '0',
            selectedIconAndIconLabel: [{ "icon": "", "iconLabel": "Select Options" },
            { 'icon': "icon-time", 'iconLabel': "Time" },
            { 'icon': "icon-date", 'iconLabel': "Date" },
            { 'icon': "icon-checkbox", 'iconLabel': "Checkbox" },
            { 'icon': "icon-paragraph", 'iconLabel': "Paragraph" },
            { 'icon': "icon-short-answer", 'iconLabel': "Short Answer" },
            { 'icon': "icon-multiple-choice", 'iconLabel': "Multiple Choice" },
            { 'icon': "icon-slider", 'iconLabel': "Slider" }]
        }
    },
    componentWillReceiveProps(nextProps) {

    },
    componentDidMount() {
        var obj = {
            followAnswer: this.props.ansId,
            answer: this.props.ans
        };
        if (this.props.ansId == '7' && this.props.ans && this.props.ans.length != 0) {
            var val = this.props.ans[0];
            var val1 = this.props.ans[1];
            var val2 = this.props.ans[2]
            obj.MaxValuesSlider = val2.data;
            obj.MaxValuesSliderOpt = val2.value;
            obj.MidValuesSlider = val1.data;
            obj.MidValuesSliderOpt = val1.value;
            obj.MinValuesSlider = val.data;
            obj.MinValuesSliderOpt = val.value;
        }

        this.setState(obj);
        this.setState({ selectedLabel: this.state.selectedIconAndIconLabel[this.props.ansId].iconLabel, selectedIcon: this.state.selectedIconAndIconLabel[this.props.ansId].icon });
    },
    midvaluesSlider() {
        if (this.state.MaxValuesSlider && this.state.MinValuesSlider) {
            return Math.ceil((parseInt(this.state.MinValuesSlider) + parseInt(this.state.MaxValuesSlider)) / 2);
        }
        else {
            return '';
        }
    },
    answerTypeHandler(e) {
        var selected = e.target.dataset.value, answer, sliderConfiguration;
        switch (selected) {
            case '3':
            case '6':
                answer = [{ name: "" }];
                break;
            case '7':
                sliderConfiguration = [{ "data": "", value: "" }];
                break;
        }
        this.setState({
            followAnswer: selected,
            answer: answer,
            selectedIcon: this.state.selectedIconAndIconLabel[e.target.dataset.value].icon,
            selectedLabel: this.state.selectedIconAndIconLabel[e.target.dataset.value].iconLabel
        });
        if (this.props.onFollowAnsChange) {
            this.props.onFollowAnsChange(selected, answer);
        }
    },
    addRow(e) {
        if (this.state.answer && this.state.answer.length < 5) {
            var answer = this.state.answer.slice();
            answer.push({ name: "" });
            this.setState({
                answer: answer
            })
            if (this.props.onFollowAnsChange) {
                this.props.onFollowAnsChange(this.state.followAnswer, answer);
            }
        }
    },
    sliderOptions(e) {
        this.setState({ SliderOption: e.target.value });
    },
    sliderOptdropdow(e) {
        this.setState({ SliderOptionDropdown: e.target.value });
    },
    deletRow(idx) {
        var answer = this.state.answer.slice();
        answer.splice(idx, 1)
        this.setState({
            answer: answer
        })
        if (this.props.onFollowAnsChange) {
            this.props.onFollowAnsChange(this.state.followAnswer, answer);
        }
    },
    sliderMinValueSlection(e) {
        this.setState({ MinValuesSlider: e.target.value });
    },
    sliderMaxValueSlection(e) {
        this.setState({ MaxValuesSlider: e.target.value });
    },

    sliderMinValueSlection(e) {

        e.target.value != '' ? this.refs.sliderMinVal.className = 'slider-value' : this.refs.sliderMinVal.className = 'slider-value error-border-bottom';

                let maxval =this.state.MaxValuesSlider ? parseInt(this.state.MaxValuesSlider) : 0;
                let x = maxval && Math.ceil((parseInt(e.target.value) + maxval) / 2);

                this.setState({ MinValuesSlider: e.target.value, MidValuesSlider: x });
                //this.setState({ MinValuesSlider: e.target.value });
    },
    sliderMaxValueSlection(e) {

        e.target.value != '' ? this.refs.sliderMaxVal.className = 'slider-value' : this.refs.sliderMaxVal.className = 'slider-value error-border-bottom';
                let minval =this.state.MinValuesSlider ? parseInt(this.state.MinValuesSlider) : 0;
                 let x = minval && Math.ceil((minval + parseInt(e.target.value)) / 2);
        this.setState({ MaxValuesSlider: e.target.value, MidValuesSlider: x  });
    },

    onslideOptionsChange(event) {
        var sliderConfiguration = [{ "data": this.state.MinValuesSlider, "value": this.refs.sliderMinanswer.value },
        { "data": this.state.MidValuesSlider, "value": this.refs.sliderMidanswer.value },
        { "data": this.state.MaxValuesSlider, "value": this.refs.sliderMaxanswer.value }
        ];
        if (this.props.onFollowAnsChange) {
            this.props.onFollowAnsChange(this.state.followAnswer, sliderConfiguration);
        }
        this.maxCharacterValue(event)
    },
    onOptionChange(ans, idx, ) {
        var answer = this.state.answer.slice();
        answer[idx].name = ans;
        this.setState({
            answer: answer
        });
        if (this.props.onFollowAnsChange) {
            this.props.onFollowAnsChange(this.state.followAnswer, answer);
        }
    },
    maxCharacterValue(event) {

      if (event.target.value.length === 140) {
          this.setState({
              Okmessage: "Max 140 characters reached.",

          })
          return false;
      }

    },

    // Not using for now.
    isValidFollowupQuestionOptions() {
        let isValidFollowupQuestionOptions = true;
        if (this.props.ansId == '7') {

            // let isValidSliderMinAns = validate.name(this.refs.sliderMinanswer);
            // isValidSliderMinAns ? this.refs.sliderMinanswer.className = 'update-mail' : this.refs.sliderMinanswer.className = 'update-mail error-border-bottom';

            // let isValidSliderMaxAns = validate.name(this.refs.sliderMaxanswer);
            // isValidSliderMaxAns ? this.refs.sliderMaxanswer.className = 'update-mail' : this.refs.sliderMaxanswer.className = 'update-mail error-border-bottom';

            // let isValidSliderMaxValue = validate.notEmpty(this.refs.sliderMaxValue.value);
            // isValidSliderMaxValue ? this.refs.sliderMaxValue.className = 'slider-value' : this.refs.sliderMaxValue.className = 'slider-value error-border-bottom';

            // let isValidSliderMinValue = validate.notEmpty(this.refs.sliderMinValue.value);
            // isValidSliderMinValue ? this.refs.sliderMinValue.className = 'slider-value' : this.refs.sliderMinValue.className = 'slider-value error-border-bottom';

            // if (isValidSliderMaxValue && isValidSliderMinValue && isValidSliderMinAns && isValidSliderMaxAns) {
            //     isValidFollowupQuestionOptions = true;
            //  }
            //  else{
            //      isValidFollowupQuestionOptions = false;
            //  }

            this.refs.sliderMinanswer.value.trim().length ? this.refs.sliderMinanswer.className = '' : this.refs.sliderMinanswer.className = '';
            this.refs.sliderMaxanswer.value.trim().length ? this.refs.sliderMaxanswer.className = '' : this.refs.sliderMinanswer.className = '';
            if (this.refs.sliderMinanswer.value.trim().length === 0 || this.refs.sliderMaxanswer.value.trim().length === 0) {
                isValidFollowupQuestionOptions = false;
            }


        }

        if (this.props.ansId == '6') {

        }


        return isValidFollowupQuestionOptions;
    },
    closebox() {
        this.setState({ Okmessage: false, modal: false, conformationModalMessage: null });
    },

    sliderAns_remove_error(e) {
        e.target.className = 'update-mail';
    },
    isValdSliderDescription(e) {
        e.target.value.trim().length > 0 ? e.target.className = 'update-mail' : e.target.className = 'update-mail error-border-bottom';
    },
    render() {

        return (
            <div className="row" >
                <div className="col-xs-7 padding-left-none">

                    {(this.state.followAnswer === '1') &&
                        <ul className="dropdown-time" >
                            <li>Time<span className="icon-time"></span></li>
                        </ul>
                    }
                    {(this.state.followAnswer === '2') &&
                        <ul className="dropdown-time" >
                            <li>Month,Date,Year<span className="icon-date"></span></li>
                        </ul>
                    }
                    {(this.state.followAnswer === '3') &&
                        <ul>
                            {
                                _.map(this.state.answer, (v, i) => {
                                    return (<Addoptions id={i} key={v.name + "_" + i} answer={v} onOptionChange={this.onOptionChange} onDelete={this.deletRow} />)
                                })
                            }

                            {this.state.answer && this.state.answer.length < 5 &&
                                <button className="addmoretext" onClick={this.addRow}><span className="icon-blue-arrow-ques"></span><span className="addmore-text">Add more option</span></button>
                            }

                        </ul>
                    }
                    {(this.state.followAnswer === '4') &&
                        <ul className="dropdown-time paragraph">
                            <li >Long answer text</li>
                        </ul>
                    }
                    {(this.state.followAnswer === '5') &&
                        <ul className="dropdown-time paragraph">
                            <li >Short answer text</li>
                        </ul>
                    }
                    {(this.state.followAnswer === '6') &&
                        <ul>                                                                     {
                            _.map(this.state.answer, (v, i) => {
                                return (<Addoptions id={i} isMulti={true} key={v.name + "_" + i} answer={v} onOptionChange={this.onOptionChange} onDelete={this.deletRow} />)
                            })
                        }

                            {this.state.answer && this.state.answer.length < 5 &&
                                <button className="addmoretext" onClick={this.addRow}><span className="icon-blue-arrow-ques"></span><span className="addmore-text">Add more option</span></button>
                            }

                        </ul>
                    }
                    {(this.state.followAnswer === '7') &&
                        <ul className="slider-options">
                            <li className="maximum-button">
                                <div className="question-selection">
                                    <select onChange={this.sliderMinValueSlection}  >
                                        <option value='' >
                                            Min
                                        </option>
                                        <option value="0" selected={this.state.MinValuesSlider == "0"}>
                                            0
                                        </option>
                                        <option value="1" selected={this.state.MinValuesSlider == "1"} >
                                            1
                                         </option>
                                    </select>
                                </div>
                            </li>
                            <li className="maximum-button">
                                <div className="question-selection">
                                    <select onChange={this.sliderMaxValueSlection}  >
                                        <option value=''  >
                                            max
                                                                    </option>
                                        <option value='2' selected={this.state.MaxValuesSlider == "2"}>
                                            2
                                                                    </option>
                                        <option value='3' selected={this.state.MaxValuesSlider == "3"} >
                                            3
                                                                    </option>
                                        <option value='4' selected={this.state.MaxValuesSlider == "4"} >
                                            4
                                                                    </option>
                                        <option value='5' selected={this.state.MaxValuesSlider == "5"} >
                                            5
                                                                    </option>
                                        <option value='6' selected={this.state.MaxValuesSlider == "6"} >
                                            6
                                                                    </option>
                                        <option value='7' selected={this.state.MaxValuesSlider == "7"} >
                                            7
                                                                    </option>
                                        <option value='8' selected={this.state.MaxValuesSlider == "8"} >
                                            8
                                                                    </option>
                                        <option value='9' selected={this.state.MaxValuesSlider == "9"} >
                                            9
                                                                    </option>
                                        <option value='10' selected={this.state.MaxValuesSlider == "10"} >
                                            10
                                                                    </option>

                                    </select>
                                </div>
                            </li>
                            <li className="slider-values">
                                <div>
                                    <input type='text' ref='sliderMinVal' className="slider-value" value={this.state.MinValuesSlider} disabled />
                                    <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMinanswer' defaultValue={this.state.MinValuesSliderOpt} onChange={this.onslideOptionsChange} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription}  ></input>
                                </div>
                                <div>
                                    <input type='text' ref="sliderMidValue" className="slider-value" value={this.state.MidValuesSlider} disabled />
                                    <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMidanswer' defaultValue={this.state.MidValuesSliderOpt} onChange={this.onslideOptionsChange} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription}    ></input>
                                </div>
                                <div>
                                    <input type='text' ref='sliderMaxVal' className="slider-value" value={this.state.MaxValuesSlider} disabled />
                                    <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMaxanswer' defaultValue={this.state.MaxValuesSliderOpt} onChange={this.onslideOptionsChange} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription}></input>
                                </div>
                            </li>
                        </ul>
                    }
                </div>
                <div className="col-xs-5 padding-right-none">
                    <div className="questionDropdown pull-right">
                        <div className="btn-group">
                            <div className="dropdown open">
                                <button className="button-drop"><span className={this.state.selectedIcon}></span> {this.state.selectedLabel}</button>
                                <ul className="dropdown-menu dropdown-menu-center">
                                    {
                                        _.map(this.props.Answertype, (Data, key) => {
                                            if (key < 7) {
                                                return (
                                                    <li key={key}  >
                                                        <a key={key} data-value={Data.id} onClick={this.answerTypeHandler}> {Data.type}</a>
                                                    </li>
                                                );
                                            }
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}
            </div>


        );
    }
});
let mapStateToProps = (state) => {
    var range = _.range(2, 10);
    return {
        SliderRange: range,
        Answertype: state.Questionnaire.AnswerType,
        uniqe: state.Questionnaire.QuestionnaireUnique
    };
};
let mapDispatchToProps = (dispatch) => ({
    QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Question));



/** WEBPACK FOOTER **
 ** ./src/components/questionnaireScreen/questions.js
 **/